import FaceWP from './modules/facetwp';
import FaceWPSort from './modules/facetwp-sort';

class App {
  constructor() {
    this.facetWp = new FaceWP();
    this.facetWpSort = new FaceWPSort();
  }

  init() {
    this.facetWp.init();
    this.facetWpSort.init();
  }
}

const app = new App();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    app.init();
    const reviews =
      document.querySelector('.facetwp-facet-reviews_search') || null;
    if (reviews !== null) {
      document.addEventListener('facetwp-refresh', () => {
        const rows = Array.from(
          document.querySelectorAll(
            '.c-products-table__body .c-products-table__row',
          ),
        );
        if (rows.length > 0) {
          rows.forEach(row => {
            const href = row.getAttribute('data-href');
            row.addEventListener('click', () => {
              window.location.assign(href);
            });
            row.addEventListener('keydown', event => {
              if (event.keyCode === 13) {
                window.location.assign(href);
              }
            });
          });
        }
      });
    }
  });
} else {
  app.init();
}
